<template lang="html">
  <div
    class="banner-contact large"
    :style="{ 'background-image': 'url(' + imageCoverURL + ')' }"
  >
    <div class="cortina"></div>
    <Navbar />
    <div class="nav-false" id="prueba"></div>
    <div class="container">
      <div class="content">
        <h2 class="title" data-aos="fade-right" data-aos-duration="1000">
          {{ title }}
        </h2>
      </div>
    </div>
    <div class="container" id="containerRef"></div>
    <div class="form" :style="{ 'margin-right': marginContainer + 'px' }">
      <FormContact />
    </div>
  </div>
</template>
<script>
import Navbar from "../General/Navbar.vue";

import FormContact from "./FormContact.vue";

export default {
  props: {
    imageCoverURL: String,
    title: String,
  },
  components: {
    Navbar,
    FormContact,
  },
  data() {
    return {
      marginContainer: 0,
    };
  },
  created() {
    window.addEventListener("resize", this.eventResizeForContainer);
    window.addEventListener("scroll", this.isScrollNavFalse);
    let htmlPage = document.querySelector("html");
    htmlPage.style.overflowY = "auto";
    window.scrollTo(0, 0);
  },
  unmounted() {
    window.removeEventListener("resize", this.eventResizeForContainer);
    window.removeEventListener("scroll", this.isScrollNavFalse);
  },
  mounted() {
    this.eventResizeForContainer();
  },
  methods: {
    eventResizeForContainer() {
      let containerRef = document.getElementById("containerRef");
      this.marginContainer = containerRef.offsetLeft;
    },
    isScrollNavFalse() {
      let navFalse = document.getElementById("prueba");
      let windowPositionY = window.pageYOffset;
      if (windowPositionY > 100) {
        navFalse.classList.add("nav-true");
      } else if (windowPositionY == 0) {
        navFalse.classList.remove("nav-true");
      }
    },
  },
};
</script>
<style lang="css" scoped>
.banner-contact {
  width: 100%;
  position: relative;
  background-size: cover;
}
.cortina {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(1, 55, 84, 0.97);
}
.banner-contact.small {
  height: 390px;
}
.banner-contact.large {
  height: 580px;
}
.banner-contact .container {
  position: relative;
  z-index: 2;
}
.banner-contact .content {
  height: calc(580px - 160px);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
}
.banner-contact.small .content {
  height: calc(390px - 160px);
}
.banner-contact .content .title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 50px;
  line-height: 59px;
  color: #ffffff;
  max-width: 640px;
  margin-bottom: 10px;
}
.banner-contact.small .content .title {
  font-weight: 300;
  font-size: 40px;
  line-height: 47px;
}
@media (max-width: 998px) {
  .banner-contact,
  .banner-contact.large {
    height: 420px;
  }
  .banner-contact .content,
  .banner-contact.large .content {
    height: calc(390px - 160px);
  }
  .banner-contact .content .title {
    font-size: 32px;
    line-height: 38px;
  }
}

.form {
  width: 610px;
  position: absolute;
  top: 180px;
  right: 0;
}
@media (max-width: 992px) {
  .form {
    padding-right: 1.5rem;
    padding-left: 1.5rem;
    width: 100%;
    margin: auto;
    margin-right: auto !important;
    top: 320px;
  }
}
.nav-false {
  height: 185px;
  display: none;
}
.nav-true {
  height: 185px;
  display: block;
}
@media (max-width: 768px) {
  .nav-true {
    height: 130px;
  }
}
</style>
